import { Component, OnInit } from '@angular/core';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';

@Component({
  selector: 'app-viewwnlistment',
  templateUrl: './viewwnlistment.component.html',
  styleUrls: ['./viewwnlistment.component.css']
})
export class ViewwnlistmentComponent implements OnInit {

  PendingTasks: any;
  MessageCount: any;
  data: any;
  Statuscompleted: any;
  selectedSmgId: any = [];
  selectedSmgIdString: string = "";
  selectedSsgId: any = [];
  selectedSsgIdString: string = "";
  currentUserData: any;
  vendorData: any;
  enlistmentStepsData: any;
  enlistmentStepsSorted: any = [];
  constructor(private vendordashboardservice: VendordashboardService, private enlistservice: EnlistmentService, private userService: UserService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;
          this.vendordashboardservice.getVendorData(currentUserId).subscribe(
            (data) => {
              this.vendorData = data;
              this.vendordashboardservice.getVendorEnlistmentSteps(currentUserId).subscribe(
                (enlistdata) => {
                  this.enlistmentStepsData = enlistdata;
                  for (var i = 0; i < this.enlistmentStepsData.length; i++) {
                    var index = this.enlistmentStepsData[i].stepNo;
                    this.enlistmentStepsSorted[index] = this.enlistmentStepsData[i];
                  }
                  this.enlistmentStepsSorted.splice(0, 1);
                }
              )
            }
          )
        }
      }
    );
  }
}
